const CLOSE_RETRY_DELAY = 30;
const CLOSE_MAX_ATTEMPTS = 10;

const loaderHandler = {
    hideLoader() {
        if (this.self == undefined) return;
        if (this.self.loadingModal == undefined) return;
        const loadingModal = this.self.loadingModal;
        const generation = this.generation;

        // react-native-modalbox only applies its opening state once the modal has laid out,
        // so a close() issued before that point is dropped and the loader stays on screen
        // forever (e.g. showLoader/hideLoader in the same tick). Wait for it to be open.
        let attempts = 0;
        const closeOnceOpen = () => {
            if (this.generation !== generation) return;
            const state = loadingModal.state || {};
            if (state.isOpen && !state.isAnimateOpen && !state.isAnimateClose) {
                loadingModal.close();
                return;
            }
            if (attempts++ < CLOSE_MAX_ATTEMPTS) {
                setTimeout(closeOnceOpen, CLOSE_RETRY_DELAY);
            }
        };
        closeOnceOpen();
    },
    showLoader(title, self = this.self) {
        if (self.props && self.props.self) {
            self = self.props.self;
        }
        if (self == undefined) return;
        if (self.loadingModal == undefined) return;
        self.loadingModal.open();
        this.self = self;
        this.generation = (this.generation || 0) + 1;
    },
};

export default loaderHandler;
